import { render } from "./BirthRecord.vue?vue&type=template&id=15c5d7bc"
import script from "./BirthRecord.vue?vue&type=script&lang=js"
export * from "./BirthRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__